import { DEFAULT_STATUSES } from '../../TaskNode/constants';
import { isStatusCompleted } from '../statusConfig';

/** Decision nodes are done when answered; missions use status category. */
export function isTaskCompleteForProgress(task, statuses = DEFAULT_STATUSES) {
  if (task?.nodeType === 'decision') {
    return task.answer != null;
  }
  if (task?.nodeType === 'wait') {
    return Boolean(task.fulfilledAt);
  }
  return isStatusCompleted(task.status, statuses);
}
